import React from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import PropTypes from 'prop-types';

import { Flex } from '../../layouts';
import { FlexRow } from '../../layouts/FlexRow';

export const StyledItem = styled(FlexRow)(
  css({
    listStyle: 'none',
  })
);

const ListItem = ({ icon, children, size }) => (
  <StyledItem
    as="li"
    gap={size === 'medium' ? 3 : 1}
    pb={size === 'medium' ? 2 : 1}
  >
    {icon && (
      <Flex flexDirection="column" minWidth="auto" alignSelf="flex-start">
        {icon}
      </Flex>
    )}
    <Flex
      flexDirection="column"
      minWidth="auto"
      alignSelf="center"
      justifyContent="flex-start"
    >
      {children}
    </Flex>
  </StyledItem>
);

ListItem.propTypes = {
  icon: PropTypes.object,
};

export default ListItem;
